<template>
  <div class="gc-step__content" ref="scrollMarker">
    <h3
      v-if="title && title.length > 0"
      class="gc-font-bold gc-text-xl gc-mb-6 gc-text-dark gc-text-center gc-font-weight-bold"
    >
      {{ title }}
    </h3>
    <div class="gc-text-sm gc-text-gray-400 gc-mb-3" v-if="hasRequiredFields">
      <span class="gc-text-gray-600 gc-text-md">*</span>
      {{ $t('requiredField') }}
    </div>

    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from '@vue/composition-api';

export default defineComponent({
  props: {
    hasRequiredFields: {
      default: false,
      type: Boolean,
    },
    title: {
      default: '',
      type: String,
    },
    valid: {
      default: true,
      type: Boolean,
    },
  },
  setup: () => {
    const scrollMarker = ref<null | HTMLElement>(null);
    const scrollToStepTop =
      process.env.VUE_APP_ENABLE_SCROLL_TO_STEP_TOP !== 'false';

    if (scrollToStepTop) {
      onMounted(() => {
        if (scrollMarker.value) {
          setTimeout(() => {
            const elementOffset =
              (scrollMarker.value?.getBoundingClientRect().top ?? 0) +
              (window.pageYOffset || document.documentElement.scrollTop) -
              120;
            window.scrollTo({
              behavior: 'smooth',
              top: elementOffset,
            });
          }, 100);
        }
      });
    }

    return { scrollMarker };
  },
});
</script>
